import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, FeatureCard } from '@feathr/components';

function MetaCreateCampaignCard(): JSX.Element {
  const { t } = useTranslation();

  return (
    <FeatureCard
      action={<Button name={'create-campaign-button'}>{t('Create campaign')}</Button>}
      dropShadow={true}
      icon={faBullhorn}
      iconDropShadow={true}
      iconTheme={'cyan'}
      label={t('Create new campaign')}
      name={'meta-create-campaign-card'}
    >
      {t('Launch a new Pixl Plus campaign to target audiences on Meta')}
    </FeatureCard>
  );
}

export default MetaCreateCampaignCard;
